import { useSelector } from "react-redux";

import { useIsLeadsCriticalDataLoading } from "app/pages/sales-intelligence/modules/leads-search/hooks/useIsLeadsCriticalDataLoading";
import { selectLegacyWorkspacesFetching } from "app/pages/sales-intelligence/sub-modules/common/store/selectors";
import { selectHubspotLoadingState } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/hubspotSelectors";
import { selectSalesforceLoadingState } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforceSelectors";
import { selectIsLoadingLists } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/suppressionListSelectors";
import { selectSignalsAreBeingFetched } from "app/pages/sales-intelligence/sub-modules/signals/store/selectors";

export const useIsLeadsPanelDataLoading = () => {
    const isLoadingSalesforce = useSelector(selectSalesforceLoadingState);
    const isLoadingHubspot = useSelector(selectHubspotLoadingState);
    const isFetchingSuppressionLists = useSelector(selectIsLoadingLists);
    const isFetchingOpportunities = useSelector(selectLegacyWorkspacesFetching);
    const areSignalsFetching = useSelector(selectSignalsAreBeingFetched);

    const areIntegrationsLoading = isLoadingSalesforce || isLoadingHubspot;

    const isLeadsCriticalDataLoading = useIsLeadsCriticalDataLoading();

    const loadingConditions: boolean[] = [
        isLeadsCriticalDataLoading,
        areIntegrationsLoading,
        areSignalsFetching,
        isFetchingSuppressionLists,
        isFetchingOpportunities,
    ];

    return loadingConditions.some(Boolean);
};
